var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<a href=\"#\" style=\"display: block;\" ng-click=\"open_reject_application_modal()\" ng-disabled=\"application.status != 'S'\" ng-if=\"application.landlord_can_edit &amp;&amp; application.show_accept_reject_button\" class=\"fancybox-modal2 reject\">Reject</a>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/acceptRejectApplication/rejectApplication/rejectApplication.jade
// module id = 488
// module chunks = 0